// extracted by mini-css-extract-plugin
export default {"cardEventMain":"Z0p8f88V","type0":"WcHaf1F1","ad-site-wrapper-small":"ad-site-wrapper-small","announce":"FEb1Pcmm","image":"wgxoDfiE","mobile":"Hndu9ZIP","time":"fUp3Nteq"};